<template>
  <el-row>
    <el-col :span="14">
      <el-form :model="node.content.options">
        <el-form-item>
          <el-input
            type="textarea"
            placeholder="Add body text"
            maxlength="1024"
            show-word-limit
            v-model="node.content.text"
            rows="5"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            type="text"
            placeholder="Optional"
            maxlength="60"
            v-model="node.content.options.footer"
            show-word-limit
          >
            <template slot="prepend">Footer</template>
          </el-input>
        </el-form-item>
        <el-form-item
          prop="catalog_id"
          :rules="[{ required: true, trigger: 'blur', message: 'Please input Catalog ID' }]"
        >
          <el-input
            type="text"
            maxlength="60"
            v-model="node.content.options.catalog_id"
            show-word-limit
            placeholder="Require"
          >
            <template slot="prepend">Catalog ID</template>
          </el-input>
        </el-form-item>
        <el-form-item
          prop="product_retailer_id"
          :rules="[{ required: true, trigger: 'blur', message: 'Please input product ID' }]"
        >
          <el-input
            type="text"
            maxlength="60"
            v-model="node.content.options.product_retailer_id"
            show-word-limit
            placeholder="Require"
          >
            <template slot="prepend">Product Retailer ID</template>
          </el-input>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "WhatsAppSingleProduct",
  props: ["node"],
};
</script>

<style></style>
